import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';

const Footer = () => {
  // Only show when viewport height is 550px or more
  const showFooter = useMediaQuery('(max-height:550px)', { noSsr: true });

  if (showFooter) {
    return null;
  }

  return (
    <Box sx={{ backgroundColor: '#000000', color: '#ffffff', textAlign: 'center', p: '4px' }}>
      <Typography variant="caption">© 2025 w‑meter. All rights reserved.</Typography>
    </Box>
  );
};

export default Footer;
